import { render, staticRenderFns } from "./PcFooter.vue?vue&type=template&id=f9530320"
var script = {}
import style0 from "./PcFooter.vue?vue&type=style&index=0&id=f9530320&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_epdqlcc3dmzbifjpwlzkpsihom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports